import React from 'react'
import "./Header.css"

function Header() {
    return (
        <div className="header">
            <img src={require('./images/GKGIF.gif')} style={{ width: '100px' }} alt="loading..." />
            <h1>GK's Random Advice</h1>
        </div>
    )
}

export default Header
